import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../../data/content';
import { OptimizedImage } from '../OptimizedImage';
function Stars() {
  return <div className="flex gap-0.5" role="img" aria-label="5 de 5 estrellas" data-id="element-448" data-mp="3hfd1ok3k3au5">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-sun text-sun" aria-hidden="true" data-id="element-449" data-mp="3r80qosoaoaib" data-mpi={i} />)}
    </div>;
}
export function Testimonials() {
  return <section className="bg-mist py-12 lg:py-20" aria-labelledby="testimonials-title" data-id="element-450" data-mp="oe6qycwl8q">
      <div className="mx-auto max-w-6xl px-5" data-id="element-451" data-mp="41hwn4t157u8">
        <h2 id="testimonials-title" className="text-center font-display text-[26px] font-extrabold leading-tight tracking-tight text-ink sm:text-4xl" style={{
        color: "#087F7B"
      }} data-id="element-452" data-mp="91w7svpxgxwh">
          Lo que dicen quienes ya lo usan
        </h2>

        <ul className="-mx-5 mt-6 flex snap-x snap-mandatory gap-3 overflow-x-auto px-5 pb-2 [scrollbar-width:none] lg:mx-0 lg:mt-10 lg:grid lg:grid-cols-3 lg:gap-4 lg:overflow-visible lg:px-0 [&::-webkit-scrollbar]:hidden" data-id="element-453" data-mp="2auaoxskndybu">
          {testimonials.map(t => <li key={t.name} className="w-[85%] shrink-0 snap-center sm:w-[48%] lg:w-auto" data-id="element-454" data-mp="1smdq7tsqaxqm">
              <figure className="flex h-full flex-col rounded-2xl bg-white p-4 ring-1 ring-brand-100" style={{
            backgroundColor: "#EAF5F2",
            backgroundImage: "none"
          }} data-id="element-455" data-mp="1nrpyzn6cbp8c">
                <figcaption className="flex items-center gap-3" data-id="element-456" data-mp="1eufkzu251lzq">
                  <OptimizedImage src={t.photo} alt={t.photoAlt} width={112} height={112} className="h-14 w-14 shrink-0 rounded-xl bg-brand-100 object-cover" data-id="element-457" data-mp="2bjx2d6ahgwh9" />
                  <span className="min-w-0" data-id="element-458" data-mp="26i7ntgo1y0of">
                    <span className="block font-display text-sm font-extrabold text-ink" data-id="element-459" data-mp="22hxje8fwribo">{t.name}</span>
                    <span className="block truncate text-xs text-ink-soft" data-id="element-460" data-mp="1xkf5s4qy4exc">
                      {t.role} · {t.place}
                    </span>
                    <span className="mt-1 block" data-id="element-461" data-mp="r1gyhzll49hf">
                      <Stars data-id="element-462" data-mp="m47c6sthsdxt" />
                    </span>
                  </span>
                </figcaption>
                <blockquote className="mt-3 text-sm leading-relaxed text-ink" data-id="element-463" data-mp="nmnw6ayfho96">“{t.quote}”</blockquote>
              </figure>
            </li>)}
        </ul>
      </div>
    </section>;
}